import {Geofence} from "../types/api/guide/geofence.types";
import {DrawnShape} from "../pages/MapMonitoring/types";


export function geofenceToDrawnShape(geofences: Geofence[] | undefined): DrawnShape[] {
    if (!geofences || !Array.isArray(geofences)) {
        return [];
    }

    const now = new Date().toISOString();

    return geofences.map((g): DrawnShape => {

        const points = g.coordinates
            .split(';')
            .map(pair => {
                const items = pair.trim().split(',')
                const lat = parseFloat(`${items[0]}.${items[1]}`);
                const lon = parseFloat(`${items[2]}.${items[3]}`);
                return [lat, lon]; // Яндекс использует [широта, долгота]
            });

        return {
            // важно: используем стабильный id с бэка (а не name)
            id: g.id || g.name || `geofence_${Date.now()}_${Math.random()}`,
            name: g.name || "Геозона",
            type: "polygon",
            description: g.description || "",
            coordinates: [points],
            style: {
                strokeColor: "#0E8F4B",
                strokeWidth: 3,
                strokeOpacity: 0.9,
                fillColor: "#0E8F4B",
                fillOpacity: 0.12,
                zIndex: 35
            },
            createdAt: now,
            updatedAt: now
        };
    });
}